module.exports = __webpack_public_path__ + "img/history_win.802ab2f2.png";